export default __webpack_public_path__ + "static/media/teamfortress.dd60cdda.jpeg";